export default "__VITE_ASSET__BFII8CeW__"